import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../../config/themes/variables/mediaqueries';
import ButtonPlus from '../../../core/ButtonPlus';
import OrderItem from '../../../core/OrderItem';
import Icon from '../../../core/Icon';
import Modal from '../../../core/Modal';
import RadioButton from '../../../core/RadioButton';
import { Checkbox } from '../../../core/Checkbox';

export const StyledConfirmationModal = styled(Modal)`
  ${mediaqueries.greaterThan('mobile')`
    min-width: ${rem('420px')};
    padding: ${rem('40px')} ${rem('32px')} ${rem('24px')} ${rem('32px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    max-width: ${rem('420px')};
    padding: ${rem('40px')} ${rem('32px')} ${rem('24px')} ${rem('32px')};
  `};
`;

export const StyledButtonsList = styled.div``;
export const StyledButtonList = styled.div``;
export const StyledBoxGeneric = styled.div`
  padding: 0 ${rem('26px')};
  ${mediaqueries.greaterThan('desktop')`
    padding: 0;
  `};
`;
export const StyledWrapperRow = styled.div`
  display: flex;
`;

export const StyledWrapperCell = styled.div`
  width: 50%;
  &:nth-child(1) {
    padding: 0 ${rem('20px')} 0 0;
  }
  &:nth-child(2) {
    padding: 0 0 0 ${rem('20px')};
  }
`;

export const StyledBoxContent = styled.div`
  padding: 0 ${rem('10px')};
  ${mediaqueries.greaterThan('desktop')`
    padding: 0 0 ${rem('10px')} 0;
    
  `};
`;

export const StyledParagraph = styled.p`
  font-size: ${props => props.theme.fontSize.small};
  line-height: ${rem('16px')};
  margin-bottom: 0;
`;

export const StyledSaveModalButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: ${rem('10px')};
`;

export const StyledDescriptionModal = styled.p`
  font-size: ${props => props.theme.fontSize.small};
  text-align: center;
  margin-bottom: ${rem('16px')};
`;

export const StyledParagraphMargin = StyledParagraph.extend`
  margin-bottom: ${rem('16px')};
`;

export const StyledList = styled.ul`
  margin: ${rem('10px')} 0 ${rem('15px')} 0;
  padding-left: ${rem('10px')};
`;

export const StyledElements = styled.li`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.small};
  padding-left: ${rem('16px')};
  :before {
    background-color: ${props => props.theme.colors.dark};
    height: ${rem('3px')};
    top: ${rem('12px')};
    width: ${rem('8px')};
  }
`;

export const StyledBoxDown = styled.div`
  margin: ${rem('19px')} 0 0 0;
  text-align: right;
  ${mediaqueries.greaterThan('desktop')`
    margin: ${rem('7px')} 0 0 0;
  `};
`;

export const StyledBoxDownCenter = StyledBoxDown.extend`
  text-align: center;
`;

export const StyledBoxInput = styled.div`
  margin-bottom: ${rem('10px')};
  width: 100%;
`;

export const StyledLabel = styled.label`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.small};
`;

export const StyledLabelError = styled.label`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.small};
  color: ${props => props.theme.colors.primary};
  margin-left: ${rem('226px')};
`;

export const LabelBlock = StyledLabel.extend`
  display: block;
  ${props =>
    props.disabled &&
    ` opacity: 0.4;
    `};
`;

export const StyledBoxModule = styled.div`
  align-items: center;
  background-color: ${props => props.theme.colors.grayLightest};
  display: flex;
  flex-wrap: wrap;
  margin-bottom: ${rem('10px')};
  padding: ${rem('12px')} ${rem('16px')} ${rem('10px')};
  position: relative;

  .input-skill {
    max-width: ${rem('100px')};
  }

  :after {
    content: '';
    background-color: ${props => props.theme.colors.light};
    height: ${rem('1px')};
    left: ${rem('20px')};
    position: absolute;
    bottom: ${rem('60px')};
    width: calc(100% - ${rem('40px')});
  }
  ${mediaqueries.greaterThan('tablet')`
    padding: ${rem('15px')} ${rem('36px')} ${rem('10px')} ${rem('36px')};
  `};
  ${props =>
    !props.tabletSize &&
    mediaqueries.greaterThan('desktop')`
    flex-wrap: nowrap;
    margin:0 0 ${rem('5px')} 0;
    padding: ${rem('12px')} ${rem('20px')} ${rem('15px')} ${rem('20px')};
    :after {
      display: none;
    }
  `};
  .input-box {
    order: 2;
    margin-left: ${rem('12px')};
    margin-top: ${rem('7px')};
  }
  .skill-label {
    margin-bottom: ${rem('4px')};
  }
  .skill-input {
    input {
      height: ${rem('43px')};
    }
  }
  .icon-trash {
    position: absolute;
    top: ${rem('4.8px')};
    right: ${rem('10px')};
    width: ${rem('25px')};
    ${mediaqueries.lessThan('desktop')`
      top: ${rem('19.6px')};
   `};
  }
`;

export const StyledBoxModuleAlignTop = StyledBoxModule.extend`
  align-items: flex-start;
  padding-left: 2rem;
  position: relative;
`;

export const StyledOrderItem = styled(OrderItem)`
  order: 2;
  ${props =>
    !props.tabletSize &&
    mediaqueries.greaterThan('desktop')`
    margin-top: ${rem('26px')};
    order:1;
  `};
`;

export const StyledBoxInputInterest = StyledBoxInput.extend`
  padding-bottom: ${rem('9px')};
  order: 1;
  position: relative;
  ${props =>
    !props.tabletSize &&
    mediaqueries.greaterThan('desktop')`
    margin: 0 0 0 ${rem('36px')};
    padding-bottom: 0;
    width:100%;
  `};
`;
export const StyledLine = styled.div`
  background-color: ${props => props.theme.colors.light};
  display: block;
  height: 100%;
  position: absolute;
  top: 0;
  left: 90px;
  width: 1px;
`;

export const StyledBoxInputEducation = StyledBoxInputInterest.extend`
  ${props =>
    !props.tabletSize &&
    mediaqueries.greaterThan('desktop')`
    margin-left: ${rem('48px')};
  `};
`;

export const StyledIcon = styled(Icon)`
  flex-basis: ${rem('25px')};
  flex-shrink: 0;
  margin-left: auto;
  top: 0.3rem;
  order: 3;
  ${props =>
    !props.tabletSize &&
    mediaqueries.greaterThan('desktop')`
    margin:  ${rem('22px')} 0 0 ${rem('37px')};
  `};
`;

export const StyledButtonPlus = styled(ButtonPlus)`
  margin: ${rem('15px')} 0 0 ${rem('16px')};
  ${mediaqueries.greaterThan('mobile')`
    margin: ${rem('20px')} 0 0 ${rem('36px')};
  `};
  ${props =>
    !props.tabletSize &&
    mediaqueries.greaterThan('desktop')`
    margin: ${rem('10px')} 0 0 0;
  `};
`;

export const StyledOrderItemSkill = styled(OrderItem)`
  order: 3;
  ${mediaqueries.greaterThan('desktop')`
    margin-top: ${rem('26px')};
    order:1;
  `};
`;

export const StyledBoxInputSkill = StyledBoxInputInterest.extend`
  ${mediaqueries.lessThan('mobile')`
    width: 85%;
  `};
`;

export const StyledBoxRadio = styled.div`
  display: flex;
  margin: 0 0 ${rem('31px')} 0;
  order: 2;
  width: 100%;
  ${mediaqueries.greaterThan('mobile')`
    align-items: center;
    margin: 0 0 0 ${rem('-25px')};
    width: ${rem('260px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    margin: ${rem('26px')} 0 0 0;
  `};
`;
export const StyledBoxRaLabel = styled(StyledBoxRadio)`
  width: 100%;
  ${mediaqueries.greaterThan('desktop')`
    width: 46%;
    margin:0;
  `};
`;

export const StyledRadioButton = styled(RadioButton)`
  margin: 0 ${rem('46px')} 0 0;
  ${mediaqueries.greaterThan('mobile')`
    margin: 0 0 0 ${rem('20px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    margin: 0 0 0 ${rem('12px')};
  `};
`;

export const StyledBoxModuleRow = StyledBoxModule.extend`
  align-items: start;

  .icon-trash {
    position: absolute;
    top: ${rem('10px')};
    right: ${rem('10px')};
    width: ${rem('25px')};
    ${mediaqueries.greaterThan('mobile')`
      top: ${rem('-10px')};
   `};
  }
`;

export const StyledBoxTwoModules = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  order: 1;
  width: 100%;
  ${mediaqueries.greaterThan('mobile')`
    flex-direction: row;
  `};
  .skill-input {
    max-width: ${rem('124px')};
  }
`;

export const StyledCheckbox = styled(Checkbox)`
  margin-top: ${rem('18px')};
`;

export const StyledButtonAdd = styled.button`
  background-color: transparent;
  border: 0;
  color: ${props => props.theme.colors.primary};
  float: right;
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('13px')};
  margin-top: ${rem('20px')};
`;
